<script lang="ts">
    import { onMount } from 'svelte'
    import DateSelect from '../../_common/date-select.svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Grid from '../../_common/z/zgrid.svelte'
    import type { Appointment } from '../../../modules/schedulerApi/appointments/appointment'
    import { AppointmentStatusFriendly } from '../../../modules/schedulerApi/appointments/appointments.enum'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import type { User } from '../../../modules/usersApi/users/user'
    import { faUser } from '@fortawesome/free-solid-svg-icons'

    let dateSelect: { from: Date; to: Date } = window.api.utils.dates.today()

    onMount(() => {
        load(dateSelect.from, dateSelect.to)
    })

    let show = false

    let grid: GridClass = null
    async function load(from: Date, to: Date) {
        if (show) return
        try {
            show = true
            let data: Appointment[] = await window.api.schedulers.appointments.getAll({ from, to })
            data = await window.api.utils.utils.assignPersonsFromObject(data)
            grid = new GridClass()
            grid.title = 'Pessoas com agendamento por item e atendente (beta)'
            //grid.subtitle = 'Período de ' + dayjs(from).format('DD/MM/YYYY') + ' até ' + dayjs(to).format('DD/MM/YYYY')
            grid.cols.push(new GridCol({ content: 'Cliente' }))
            grid.cols.push(new GridCol({ content: 'Telefone', type: GridColTypeEnum.phone }))
            grid.cols.push(new GridCol({ content: 'Data', type: GridColTypeEnum.datetime }))
            grid.cols.push(new GridCol({ content: 'Atendente' }))
            grid.cols.push(new GridCol({ content: 'Serviço' }))
            grid.cols.push(new GridCol({ content: 'Status', size: 2 }))
            grid.cols.push(new GridCol({ content: 'Valor', type: GridColTypeEnum.float_2, showTotal: true }))
            grid.cols.push(new GridCol({ type: GridColTypeEnum.button }))
            for (let appointment of data) {
                appointment.items = await window.api.utils.utils.assignServicesFromObject(appointment.items)
            }
            console.log('relat.data', data)
            for (const appointment of data) {
                if (appointment.status === 'agendamento_bloqueado') continue
                appointment.items = await window.api.utils.utils.assignUsersFromObject(appointment.items, false, undefined, undefined, true)
                for (const item of appointment.items) {
                    if (item.service?.type === 'package') continue
                    let line: GridLine = new GridLine()
                    line.slots.push({ content: appointment['person']?.name })
                    line.slots.push({ content: appointment['person']?.phone })
                    line.slots.push({ content: appointment.start })
                    line.slots.push({ content: item.user?.userName || '-' })
                    line.slots.push({ content: item.service?.name || '-' })
                    line.slots.push({ content: AppointmentStatusFriendly[appointment.status] })
                    line.slots.push({ content: item.comissionPrice })
                    line.slots.push({ content: [new GridButton({ callback: () => window.person('show', appointment.personId), icon: faUser })] })
                    grid.lines.push(line)
                }
            }
            console.log('relat.grid', grid)
            grid = grid
        } catch (error) {
        } finally {
            show = false
        }
    }

    function dateChanged(event) {
        dateSelect = event.detail
        load(dateSelect.from, dateSelect.to)
    }
</script>

<div class="relat-body">
    <div class="acts h-print">
        <div class="date">
            <DateSelect on:change={dateChanged} />
        </div>
    </div>
    <div class="grid mt-2">
        <Grid {grid} />
    </div>
</div>
<LoadSpinner {show}></LoadSpinner>

<style>
    .grid {
        max-width: 100%;
    }
</style>
